import * as actionTypes from '../actions/actionTypes';

const initialState = {
  id: null,
  url: null,
  status: 'idle',
};

// Holds the Formstack form-session URL and id returned by the `ellis` prefill proxy. This is
// transient PII-adjacent state: it is never persisted to sessionStorage or cookies, and it is
// registered as per-application state in `reducers/index.js` so CLEAR_APPLICATION_DATA wipes it
// between applications.
export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.CREATE_FORMSTACK_PREFILL_REQUEST:
      return { id: null, url: null, status: 'loading' };
    case actionTypes.CREATE_FORMSTACK_PREFILL_SUCCESS:
      return { id: action.id || null, url: action.url || null, status: 'success' };
    case actionTypes.CREATE_FORMSTACK_PREFILL_ERROR:
      return { id: null, url: null, status: 'error' };
    default:
      return state;
  }
}
